// GetNet broadband plan data
// Speeds × durations price matrix

export const SPEEDS = [
  { label: 'Demo Plan (₹1)', value: 'demo' },
  { label: '10 Mbps',        value: '10'   },
  { label: '30 Mbps',        value: '30'   },
  { label: '50 Mbps',        value: '50'   },
  { label: '100 Mbps',       value: '100'  },
  { label: '300 Mbps',       value: '300'  },
]

export const DURATIONS = [
  { label: '30 Days',  value: '30'  },
  { label: '90 Days',  value: '90'  },
  { label: '180 Days', value: '180' },
  { label: '360 Days', value: '360' },
]

// Price matrix: speed → duration → price (INR)
// Demo plan always costs ₹1 regardless of duration
export const PRICE_MATRIX = {
  demo: { '30': 1,    '90': 1,    '180': 1,    '360': 1    },
  '10': { '30': 412,  '90': 1058, '180': 1763, '360': 2999 },
  '30': { '30': 471,  '90': 1235, '180': 2117, '360': 3599 },
  '50': { '30': 707,  '90': 1943, '180': 3533, '360': 5999 },
  '100':{ '30': 825,  '90': 2297, '180': 4241, '360': 7774 },
  '300':{ '30': 1200, '90': 2999, '180': 4999, '360': 8999 },
}

// Returns price given speed and duration values
// Returns null if either is not yet selected
export function getPrice(speed, duration) {
  if (!speed || !duration) return null
  return PRICE_MATRIX[speed]?.[duration] ?? null
}

// Returns the human-readable label for a speed value
export function getSpeedLabel(value) {
  return SPEEDS.find(s => s.value === value)?.label ?? value
}

// Returns the human-readable label for a duration value
export function getDurationLabel(value) {
  return DURATIONS.find(d => d.value === value)?.label ?? value
}

// GetNet contact details
export const GETNET = {
  upiId:    'abhishek321jadhav@okicici',
  phone:    '918652816746',     // WhatsApp number (no + prefix for wa.me)
  name:     'GetNet Broadband',
}
